import { render, staticRenderFns } from "./TranscribingFile.vue?vue&type=template&id=d027c20c&scoped=true&"
import script from "./TranscribingFile.vue?vue&type=script&lang=js&"
export * from "./TranscribingFile.vue?vue&type=script&lang=js&"
import style0 from "./TranscribingFile.vue?vue&type=style&index=0&id=d027c20c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d027c20c",
  null
  
)

export default component.exports